.popover {
    --base-popover-padding: var(--spacing-lg);
    --popover-min-width: 240px;
    --popover-max-width: 340px;
    border-radius: 8px;
    /* The popover grows naturally with its content (the disclosure
       animation works against this). RAC's useOverlayPosition sets an
       inline `max-height` based on viewport space, which clamps growth
       at the visible viewport. `overflow-y: auto` then routes any further
       content (e.g., a long FeatureToggles list with every section
       expanded) to an internal scroll rather than spilling past the
       bottom of the browser window. */
    overflow-y: auto;
}

.dialog {
    outline: none;
}

.dialogContent {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-lg);
    /* RAC's <Dialog> renders as <section>; without an explicit font-family
       the descendants inherit whatever the surrounding host (Storybook
       canvas, autodocs page) provides — which can be a UA serif. */
    font-family: var(--fontFamilySansRegular), Arial, Helvetica, sans-serif;
    color: var(--colorTextPrimary);
}

.menu {
    outline: none;
    display: flex;
    flex-direction: column;
    gap: var(--base-menu-item-gap, 10px);
    --menu-item-button-margin-inline: calc(-1 * var(--spacing-xs));
}

.profileInfo {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-xxs);
    align-items: flex-start;
}

.roleTags {
    display: flex;
    flex-direction: row;
    gap: var(--spacing-xxs);
}

.email {
    font-family: var(--fontFamilySansRegular), sans-serif;
    font-size: 14px;
    line-height: 1.5;
    color: var(--colorTextPrimary);
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
